const LIGHT_SCHEME_QUERY = '(prefers-color-scheme: light)';

function lightSchemeMediaQuery(): MediaQueryList | null {
  if (typeof window === 'undefined' || !window.matchMedia) return null;
  return window.matchMedia(LIGHT_SCHEME_QUERY);
}

/** True when the OS prefers a light color scheme. */
export function prefersLightColorScheme(): boolean {
  return lightSchemeMediaQuery()?.matches ?? false;
}

/** Subscribe to OS color-scheme changes. */
export function onColorSchemeChange(listener: () => void): void {
  lightSchemeMediaQuery()?.addEventListener('change', listener);
}
